import { routerUrlOrFalse } from "Utils/routerUrl";

export const resolvePartnerURLSegment = (pathname: string, routerPath: string | false | null | undefined): string => {
  if (routerPath) {
    return routerPath;
  }
  return pathname.startsWith("/zero") ? "/zero" : "";
};

export const partnerURLSegment = (): string => resolvePartnerURLSegment(window.location.pathname, routerUrlOrFalse());
